import {Injectable} from '@angular/core';
import {fromEvent, merge, Subscription} from 'rxjs';
import {throttleTime} from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class UserActivityService {
    private subscriptions: Subscription[] = [];
    private debug = false;

    private readonly THROTTLE_INTERVAL_S = 10;

    constructor() {
    }

    init(onActivityDetected: () => void): void {
        const activityEvents = merge(
            fromEvent(window, 'click'),
            fromEvent(window, 'keydown'),
            fromEvent(window, 'touchstart')
        ).pipe(
            // Throttle input to prevent too frequent checks
            throttleTime(this.THROTTLE_INTERVAL_S * 1000)
        );

        this.subscriptions.push(activityEvents.subscribe((data: Event) => {
            if (this.debug) {
                console.log('[UserActivityService] User activity detected.');
            }

            onActivityDetected();
        }));
    }

    clear(): void {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
